"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SLATE_DEFAULT_BLOCK_TYPE = exports.SLATE_BLOCK_PARENT_TYPES = void 0;
const SLATE_DEFAULT_BLOCK_TYPE = 'paragraph';
exports.SLATE_DEFAULT_BLOCK_TYPE = SLATE_DEFAULT_BLOCK_TYPE;
const SLATE_BLOCK_PARENT_TYPES = ['list-item', 'quote'];
exports.SLATE_BLOCK_PARENT_TYPES = SLATE_BLOCK_PARENT_TYPES;